export default {
  // CANCEL CARD(S)
  "___cancel-card-general_action_cancel": "",
  "___cancel-card-general_action_confirm": "",
  "___cancel-card-general_action_done": "",
  "___cancel-card-general_title_confirm-close": "",
  "___cancel-card-general_text_confirm-close": "",
  "___cancel-card-general_action_confirm-close_cancel": "",
  "___cancel-card-general_action_confirm-close_confirm": "",

  // CANCEL ALL CARDS
  "cancel-all-cards_page-title": "Are you sure you'd like to cancel this card?",
  "cancel-all-cards_page-description": "Canceling will immediately inactivate all cards and permanently remove them from your account.",
  "___cancel-all-cards_action_cancel": "",
  "___cancel-all-cards_action_confirm": "",
  "___cancel-all-cards_action_done": "",
  "___cancel-all-cards_title_confirm-close": "",
  "___cancel-all-cards_text_confirm-close": "",
  "___cancel-all-cards_action_confirm-close_cancel": "",
  "___cancel-all-cards_action_confirm-close_confirm": "",
  "cancel-all-cards_text_loading-message": "Canceling All Cards…",
  "cancel-all-cards_text_success-message": "All cards have been canceled on this account, and a confirmation was sent to the email address associated with this account. You can still pay bills and get reimbursed for eligible expenses using the mobile app or the portal.",
  "cancel-all-cards_text_refresh-data-error-message": "Your debit cards have been cancelled but we were unable to refresh the data on the screen. Please refresh the page.",

  // CANCEL CARD
  "cancel-card_page-title": "Are you sure you'd like to cancel this card?",
  "cancel-card_page-description": "Canceling will immediately inactivate the card and permanently remove it from your account.",
  "___cancel-card_action_cancel": "",
  "___cancel-card_action_confirm": "",
  "___cancel-card_action_done": "",
  "___cancel-card_title_confirm-close": "",
  "___cancel-card_text_confirm-close": "",
  "___cancel-card_action_confirm-close_cancel": "",
  "___cancel-card_action_confirm-close_confirm": "",
  "cancel-card_text_loading-message": "Canceling Card…",
  "cancel-card_text_success-message": "This card has been canceled, and a confirmation was sent to the email address associated with this account. You can request a new debit card from the Payment and Banking screen.",
  "cancel-card_text_refresh-data-error-message": "Your debit card has been cancelled but we were unable to refresh the data on the screen. Please refresh the page.",
};